import { useQuery } from '@tanstack/react-query';

import TaxonomiesService from '@/services/TaxonomiesService';

export const GET_TAXONOMIES_VERSIONS_QUERY_KEY = ['taxonomies-versions'];

export function useGetTaxonomiesVersions() {
  const { data, isFetching } = useQuery({
    queryKey: GET_TAXONOMIES_VERSIONS_QUERY_KEY,
    queryFn: () => TaxonomiesService.getTaxonomiesVersions(),
  });

  return {
    versions: data,
    isLoading: isFetching,
  };
}
